import thunk from 'redux-thunk'
import Browser from '../services/Browser'
import { createReducer } from '../reducers'
import { createStore, applyMiddleware } from 'redux'

const { ENVIRONMENT } = process.env.ENV_VALUES
const middlewares = [thunk]

if (ENVIRONMENT !== 'production' && !Browser.isIE()) {
	const { createLogger } = require('redux-logger')
	const logger = createLogger()
	middlewares.push(logger)
}

/**
 * The state three
 */
const store = createStore(createReducer(), applyMiddleware(...middlewares))
store.async = {}

export default store
